import * as React from 'react'

import { type PaletteProps, type TypographyProps } from '@material-ui/system'
import { useSelector } from 'react-redux'

import { type CurrencyName } from '@webapp/core/entities/external/Currency/CurrencyName'
import { useFormatPrice } from '@webapp/core/hooks/useFormatPrice'
import { makeSelectBaseCurrency } from '@webapp/core/stores/global'
import { PriceStyled } from './styles/PriceStyled'

export interface IPriceProps extends TypographyProps, PaletteProps {
  currency?: CurrencyName
  price: number | string
  mdp?: boolean
  useSystemLocale?: boolean
  inline?: boolean
}

export const Price = ({
  currency,
  price,
  fontSize,
  mdp = false,
  inline = false,
  useSystemLocale,
  ...otherProps
}: IPriceProps) => {
  const formatPrice = useFormatPrice({
    mdp,
    useSystemLocale,
  })

  // Currency is either from props or from the global store
  const baseCurrency = useSelector(makeSelectBaseCurrency())
  const currencyName = currency || baseCurrency.name

  return (
    <PriceStyled
      as={inline ? 'span' : 'div'}
      fontSize={fontSize}
      {...otherProps}
    >
      {formatPrice(price)} {currencyName.toUpperCase()}
    </PriceStyled>
  )
}

Price.displayName = 'Price'
